(ns app.front.view.workspace.property-subs
  (:require [app.domain.address.model :as address-model]
            [app.domain.group.model :as group-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.navigation :as navigation]
            [app.front.view.wizard.property-selector :as property-selector]
            [app.front.view.workspace.map :as workspace-map]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.feature-flags :as ff]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(def state-path (rf/path [::state]))

(defn set-visible [visible-thing-key {:keys [db]} _]
  {:db         (-> db
                   (dissoc ::state)
                   (assoc-in [::state visible-thing-key] true))
   :dispatch-n (cond-> [[::workspace-map/set-map-extended true]]
                 (not (ff/enabled? :feature-flag.id/property-db-units))
                 (conj [::navigation/scroll-to-top]))})


(rf/reg-event-fx ::set-add-visible
  (partial set-visible ::add-visible?))


(rf/reg-event-fx ::set-change-property-visible
  (partial set-visible ::change-property-visible?))


(rf/reg-event-fx ::cancel-add
  (fn [{:keys [db]} _]
    {:db       (dissoc db ::state)
     :dispatch [::workspace-map/set-map-extended false]}))


(rf/reg-event-db ::clear-state
  (fn [db _]
    (dissoc db ::state)))


(rf/reg-sub ::state
  :-> ::state)


(rf/reg-sub ::add-visible?
  :<- [::state]
  :-> ::add-visible?)


(rf/reg-sub ::change-property-visible?
  :<- [::state]
  :-> ::change-property-visible?)


(rf/reg-sub ::property-widget-visible?
  :<- [::add-visible?]
  :<- [::change-property-visible?]
  (fn [[add-visible? change-property-visible?]]
    (or add-visible? change-property-visible?)))


(rf/reg-event-fx ::set-candidate
  (fn [{:keys [db]} [_ domain-group-id status data]]
    (let [success? (= 200 status)]
      {:db       (-> (if success?
                       (assoc-in db [::state ::candidate] (dissoc data :municipality))
                       (update db ::state dissoc ::candidate))
                     (assoc-in [::state ::loading-point?] false))
       :dispatch (when success? [::property-selector/fetch-property-attributes domain-group-id data])})))


(rf/reg-event-db ::set-candidate-from-address-search
  (fn [db [_ data]]
    (assoc-in db [::state ::candidate] (dissoc data :municipality))))


(rf/reg-event-fx ::search-error
  (fn [{:keys [db]} [_ _ {:keys [error]}]]
    {:db       (-> (update db ::state dissoc ::candidate)
                   (assoc-in [::state ::loading-point?] false))
     :dispatch [:notifications/add
                :toast
                :warning
                :error/gis-result-not-found
                error]}))


(rf/reg-event-db ::clear-candidate #(update % ::state dissoc ::candidate))


(rf/reg-sub ::candidate
  :<- [::state]
  (fn [{::keys [candidate]} _]
    candidate))

(rf/reg-sub ::additional-property-geometries
  :<- [::ws-subs/workspace]
  :<- [::candidate]
  (fn [[workspace candidate] _]
    (cond-> (->> workspace
                 :workspace/properties
                 (filter (workspace-model/is-secondary-property-fn workspace))
                 (map (fn [property]
                        (-> property :entity/location :location/shape))))
      (:geometry candidate) (conj (:geometry candidate)))))


(rf/reg-sub ::candidate-point
  :<- [::candidate]
  :-> :geometry-point)


(rf/reg-sub ::loading-point?
  :<- [::state]
  (fn [{::keys [loading-point?]}]
    loading-point?))

(defn pick-address [gis-address manual-address]
  (cond
    (nil? (address-model/address-checker gis-address))
    gis-address

    (nil? (address-model/address-checker manual-address))
    manual-address

    :else nil))

(rf/reg-sub ::property-ids
  (fn [[_ target-id]]
    (rf/subscribe [::entities/entity target-id]))
  (fn [target-entity _]
    (->> target-entity
         :entity/parent
         :workspace/properties
         (map :property/id)
         set)))

(rf/reg-sub ::already-added?
  (fn [[_ target-id]]
    [(rf/subscribe [::candidate])
     (rf/subscribe [::property-ids target-id])
     (rf/subscribe [::change-property-visible?])])
  (fn [[candidate property-ids change-property?] _]
    (and
      ;; when changing property, we don't care if same property is selected again
      (not change-property?)
      (property-ids (-> candidate :property :property/id)))))

(rf/reg-sub ::candidate-valid?
  (fn [[_ target-id]]
    [(rf/subscribe [::candidate])
     (rf/subscribe [::create-v2/manual-address])
     (rf/subscribe [::loading-point?])
     (rf/subscribe [::already-added? target-id])])
  (fn [[candidate manual-address loading? already-added?] _]
    (and (-> candidate :property :property/id str/blank? not)
         (pick-address (:address candidate) manual-address)
         (not loading?)
         (not already-added?))))



(rf/reg-event-fx ::do-add-property
  (fn [{:keys [db]} [_ signal target-id]]
    {:db       (assoc-in db [::state ::in-progress?] true)
     :dispatch [::process/signal
                target-id
                [signal
                 (p/assoc-if
                   (-> db ::state ::candidate)
                   :address (pick-address (-> db ::state ::candidate :address)
                                          (-> db ::create-v2/manual-address))
                   :geometry (-> db ::state ::candidate :geometry))]
                {:on-success [::add-done]
                 :on-done    [::reset-loading]
                 :notify     {:success (if (= signal :process.signal/change-primary-property)
                                         :workspace/property-changed
                                         :workspace/property-added)}}]}))

(rf/reg-event-fx ::add-done
  (fn [{:keys [db]} _]
    {:db       (dissoc db ::state)
     :dispatch [::workspace-map/set-map-extended false]}))

(rf/reg-event-db ::reset-loading
  (fn [db _]
    (assoc-in db [::state ::in-progress?] false)))

(rf/reg-sub ::in-progress?
  :<- [::state]
  :-> ::in-progress?)

(rf/reg-event-fx ::on-map-click
  (fn [{:keys [db]} [_ property-types domain-group-id municipality coordinates]]
    (let [layer-ids (if (ff/enabled? :feature-flag.id/public-works-location-enhancements)
                      (::create-v2/layer-id-order db)
                      [])]
      {:db           (-> db
                         (assoc-in [::state ::loading-point?] true)
                         (assoc-in [::state ::candidate] nil))
       :dispatch     [::gis-search/address-search-input domain-group-id ""]
       :comm/command {:command        :address/point-search
                      :data           (util/mmap {:sourceCRS      "3857"
                                                  :property-types property-types}
                                                 layer-ids
                                                 municipality
                                                 domain-group-id
                                                 coordinates)
                      :on-success     [::set-candidate domain-group-id]
                      :on-not-found   [::search-error]
                      :on-bad-gateway [::search-error]}})))

(rf/reg-sub ::create-property-modal-open?
  :<- [::state]
  (fn [state _]
    (::create-property-modal-open? state false)))

(rf/reg-event-db ::open-create-property-modal
  state-path
  (fn [state _]
    (assoc state ::create-property-modal-open? true)))

(rf/reg-event-db ::close-create-property-modal
  state-path
  (fn [state _]
    (dissoc state
            ::create-property-modal-open?
            ::redirect-to-property-view?)))

(rf/reg-event-db ::toggle-property-view-redirect
  state-path
  (fn [state _]
    (update state ::redirect-to-property-view? not)))

(rf/reg-sub ::redirect-to-property-view?
  :<- [::state]
  :-> ::redirect-to-property-view?)

(rf/reg-sub ::property-manager?
  :<- [::ws-subs/workspace]
  :<- [:session/user]
  (fn [[workspace user] _]
    (let [domain-group (-> workspace
                           :domain/authority-group
                           :entity/parent)]
      (and (group-model/has-feature? domain-group
                                     :group.feature/property-management)
           (-> user
               :user/domain-groups
               (p/find-first {:db/id (:db/id domain-group)})
               :group-roles
               (contains? :group.role/property-management))))))

(rf/reg-event-fx ::create-property
  state-path
  (fn [{state :db} [_ target-id]]
    {:db (assoc state ::in-progress? true)
     :fx [[:dispatch [::process/signal
                      target-id
                      [:process.signal/create-primary-property]
                      (p/assoc-if
                        {:notify  {:success :workspace/property-created}
                         :on-done [::reset-loading]}
                        :on-success (when (::redirect-to-property-view? state)
                                      [::redirect-to-property-view]))]]]}))

(rf/reg-event-fx ::redirect-to-property-view
  (fn [_ [_ _status body]]
    {:route/push {:route  :view/property
                  :params {:db-id (entities/id-of-some-in-apply-changes
                                    :entity.type/property
                                    body)}}}))
